
export enum OriginFilterType {
    TRACK = "TRACK",
    JOB = "JOB",
    RANKING = "RANKING",
}

export interface OriginFilter {
    id: string;
    name: string;
    origin_type: OriginFilterType;
}
